import React, { memo } from "react";
import { isEmpty } from "lodash";
import {
  convertEpochToDate,
  convertEpochToDate_withouttime,
} from "../../utilities/helpers.js";
import Spinners from "../Spinner.jsx";
import styles from "./Table.module.scss";
import PropTypes from "prop-types";

function DetailsPopup(props) {
  const { actionOwner, tableLoading, value } = props;
  return (
    <>
      <div className="table-responsive custom_scroll">
        <table id="popupdata" className={`mt-4 ${styles.popupdata}`}>
          <thead>
            <tr>
              <th colSpan={actionOwner ? "6" : "5"}>System Admin</th>
              <th colSpan="3">CISO</th>
              <th rowSpan="2">Status</th>
            </tr>
            <tr className={`${styles.popupdata}`}>
              <th className="text-start">Action Plan</th>
              {actionOwner && <th className="text-start">Action Owner</th>}
              <th className="text-start">Description</th>
              <th className="text-start">Target Date</th>
              <th className="text-start">Requested By</th>
              <th className="text-start">Requested On</th>
              <th className="text-start">Comment</th>
              <th className="text-start">Commented By</th>
              <th className="text-start">Commented On</th>
            </tr>
          </thead>
          <tbody>
            {tableLoading ? (
              <tr>
                <td
                  className={styles.modalprojectemty}
                  colSpan={actionOwner ? "10" : "9"}
                >
                  <Spinners />
                </td>
              </tr>
            ) : value.length > 0 ? (
              value.map((item) => {
                const targetDate = new Date(item.targetDate);
                targetDate.setHours(23, 59, 59, 999); // End of that day

                const now = new Date(); // current time

                const shouldHighlight = now > targetDate;
                const redHighlight = shouldHighlight
                  ? "tableRedHighlight"
                  : null;

                return (
                  <tr key={item.id}>
                    <td className={`text-start ${redHighlight}`}>
                      {!isEmpty(item.actionPlan) ? item.actionPlan : "-"}
                    </td>
                    {actionOwner &&
                      (item.status !== "Open" ? (
                        <td className={`text-start ${redHighlight}`}>
                          {!isEmpty(item.taskOwner) ? item.taskOwner : "-"}
                        </td>
                      ) : null)}
                    <td className={`text-start ${redHighlight}`}>
                      {!isEmpty(item.description) ? item.description : "-"}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {item.targetDate
                        ? convertEpochToDate_withouttime(item.targetDate)
                        : "-"}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {!isEmpty(item.requestedBy) ? item.requestedBy : (!isEmpty(item.userName) ? item.userName : "-")}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {item.requestedDate
                        ? convertEpochToDate_withouttime(item.requestedDate)
                        : item.requestDate
                        ? convertEpochToDate(item.requestDate)
                        : "-"}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {!isEmpty(item.comment) ? item.comment : "-"}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {!isEmpty(item.cisoCommentBy)
                        ? item.cisoCommentBy
                        : item?.commentedBy
                        ? item?.commentedBy
                        : "-"}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {item.commentedOn
                        ? convertEpochToDate_withouttime(item.commentedOn)
                        : item.cisoCommentDate
                        ? convertEpochToDate(item.cisoCommentDate)
                        : "-"}
                    </td>
                    <td className={`text-start ${redHighlight}`}>
                      {!isEmpty(item.status) ? item.status : "-"}
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td
                  className={styles.modalprojectemty}
                  colSpan={actionOwner ? "10" : "9"}
                >
                  No Data Available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default memo(DetailsPopup);
DetailsPopup.propTypes = {
  actionOwner: PropTypes.bool,
  tableLoading: PropTypes.bool,
  value: PropTypes.arrayOf(PropTypes.object),
};

DetailsPopup.defaultProps = {
  actionOwner: false,
  tableLoading: false,
  value: [],
};
